import { Checkbox } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  containerCss,
  listCss,
  checkboxCustomCss,
  errorCss,
} from "./SubjectSelector.style";

const propTypes = {
  // React node to render section title.
  title: PropTypes.string.isRequired,
  // Grid data array.
  subjects: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      checked: PropTypes.bool,
    }),
  ),
  // Callback function to change grid data array.
  onSubjectsChange: PropTypes.func.isRequired,
  editable: PropTypes.bool,
  onBlur: PropTypes.func,
  error: PropTypes.string,
};

const EMPTY_FN = () => false;

const SubjectSelector = (props) => {
  const { title, subjects, onSubjectsChange, editable, error, onBlur } = props;

  return (
    <fieldset css={containerCss}>
      <legend>{title}</legend>

      <div css={listCss}>
        {subjects.map((subject) => (
          <Checkbox
            __cssFor={checkboxCustomCss}
            key={subject.id}
            label={subject.name}
            name={subject.name}
            value={subject.name}
            checked={subject.checked}
            disabled={!editable}
            onClick={() =>
              onSubjectsChange(subject.name, subject.id, !subject.checked)
            }
            onBlur={onBlur || EMPTY_FN}
          />
        ))}
      </div>
      {error && <span style={errorCss}>{error}</span>}
    </fieldset>
  );
};

const defaultProps = {
  editable: true,
};

SubjectSelector.propTypes = propTypes;
SubjectSelector.defaultProps = defaultProps;

export default SubjectSelector;
